import { LoaderCircle, Sparkles } from "lucide-react";
import type { SummaryOrigin } from "@/shared/types/mention";
import type { MentionSummaryState } from "./use-mention-summary";

/** O rótulo discreto do resumo: "Resumo da IA" ou, sob pedido, a origem. */
export function summaryLabel(origin: SummaryOrigin | null): string {
  return origin === "on_demand" ? "Resumo da IA · gerado sob pedido" : "Resumo da IA";
}

/** O resumo com o rótulo em cima. Sem negrito dos termos: ele é sobre o
 *  texto da publicação, e o resumo não o carrega. */
export function SummaryText({
  summary,
  origin,
  className = ""
}: {
  summary: string;
  origin: SummaryOrigin | null;
  className?: string;
}) {
  return (
    <div className="mention-summary">
      <span className="mention-summary-label">
        <Sparkles size={12} aria-hidden="true" /> {summaryLabel(origin)}
      </span>
      <p className={`mention-summary-text ${className}`.trim()}>{summary}</p>
    </div>
  );
}

/** "Gerar resumo" (ou "Gerar de novo"), com o giro enquanto espera e a
 *  falha escrita logo abaixo, no próprio componente. */
export function GenerateSummary({
  state,
  label = "Gerar resumo"
}: {
  state: MentionSummaryState;
  label?: string;
}) {
  return (
    <span className="mention-summary-generate">
      <button
        type="button"
        className="mention-summary-button"
        disabled={state.generating}
        onClick={() => void state.generate()}
      >
        {state.generating ? (
          <LoaderCircle size={13} className="spin" aria-hidden="true" />
        ) : (
          <Sparkles size={13} aria-hidden="true" />
        )}
        {state.generating ? "Gerando…" : label}
      </button>
      {state.error && (
        <span className="form-error mention-summary-error" role="alert">
          {state.error}
        </span>
      )}
    </span>
  );
}
